import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HuggingfaceService {
  private apiUrl = 'https://api-inference.huggingface.co/models/';
  private modelId = 'iamsuman/finetuned-sentiment-distilbert-base-uncased-model-3000'; // Replace with the model ID you want to use
  private apiToken = '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'; // Replace with your Hugging Face API token

  constructor(private http: HttpClient) {}

  makeRequest(payload: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.apiToken}`,
      'Content-Type': 'application/json'
    });

    const requestUrl = `${this.apiUrl}${this.modelId}`;
    return this.http.post<any>(requestUrl, { inputs: payload }, { headers });
  }
}
